export class LocalCostLabel {
  constructor(
    public label = "",
    public location,
  ) {}

  public getRequestParams() {
    return {
      label: this.label,
      location: this.location.getId(),
    };
  }
}
